import { useMutation } from '@tanstack/react-query';
import { useApiPost } from 'mf_core/query';

export const useQuoteProductInformation = () => {
  const apiPost = useApiPost<ProductInformationResponse>();
  return useMutation({
    mutationFn: (body: ProductInformationPayload[]) => {
      const data = apiPost('/quote-exp/v1/ProductInformation', body);
      return data;
    },
  });
};

export interface ProductInformationPayload {
  branchNumber?: string;
  quantity?: number;
  skuVpnNumber?: string;
}

export interface ProductInformationResponse {
  discontinuedSkus: string;
  discontinuedVpns: string;
  duplicateSkus: ValidSku[];
  invalidSkus: string;
  invalidVpns: string;
  isCMPProduct: boolean;
  maskedSkus: string;
  noDirectShipOrderableSkus: string;
  noDirectShipOrderableVpns: string;
  unAuthorizedSkus: string;
  unAuthorizedVpns: string;
  validSkus: ValidSku[];
}

export interface ValidSku {
  productDetails: ProductDetail[];
  vendorPartNumber: string;
}

export interface ProductDetail {
  bundle: any[];
  bundleSkus: string[];
  harmonizedCode: any;
  ingramPartNumber: string;
  longDescription: string;
  msrp: number;
  partOfBunddles: any[];
  productImage: string;
  shortDescription: string;
  totalAvailableQuantity: number;
  unitPrice: number;
  vendorName: string;
  vendorNumber: string;
  vendorPartNumber: string;
}
